// CORRESPONDENCE — handwritten letter-of-application form. NO portrait, NO headshot.
export default function Apply() {
  return (
    <div className="bg-[#F4EEE0] text-[#1A1410] min-h-screen">
      <section className="pt-32 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-[3px] border-[#1A1410]">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#7B1A1A] mb-3">— § IV / Correspondence — write back, on paper if you prefer</p>
        <h1 className="font-serif italic text-[44px] lg:text-[88px] leading-[0.95]">A letter to Mira.</h1>
      </section>

      <section className="max-w-[1100px] mx-auto px-8 lg:px-14 py-14 grid lg:grid-cols-[1fr_280px] gap-12 items-start">
        {/* LETTER FORM */}
        <form onSubmit={(e) => e.preventDefault()} className="bg-white border border-[#1A1410]/20 p-8 lg:p-12 shadow-[0_2px_0_rgba(26,20,16,0.08)]">
          <div className="border-b-[3px] border-[#1A1410] pb-3 mb-8 flex items-baseline justify-between">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B1A1A]">— Application by post —</p>
            <p className="font-mono text-[10px] tracking-[0.28em] uppercase text-[#1A1410]/55">No. 4 / 2026</p>
          </div>
          <p className="font-serif italic text-2xl text-[#1A1410]/85 mb-2">Dear Mira,</p>
          <p className="font-serif text-base text-[#1A1410]/65 leading-[1.7] mb-7">All applications are read by Mira personally. Replies arrive within seven working days, by hand, with one of three answers: yes, no, or come back next quarter. Apply only if you are prepared for any of the three.</p>
          <div className="grid grid-cols-2 gap-x-6 gap-y-5">
            <Field label="Your name" testId="mv-form-name" />
            <Field label="Your title & firm" testId="mv-form-title" />
            <Field label="Email" type="email" testId="mv-form-email" />
            <SelectField label="Country" testId="mv-form-country" options={['United States','United Kingdom','Germany','France','Singapore','Japan','Other']} />
            <SelectField label="Which mode" testId="mv-form-mode" options={['Mode A · Private coaching (6 mo · $48k)','Mode B · Workshop · Off-the-Record ($42k)','Mode C · Lecture · Keynote ($28k)','Not sure — advise me']} />
            <SelectField label="Timing" testId="mv-form-timing" options={['Q2 2026','Q3 2026','Q4 2026','2027 onward']} />
            <div className="col-span-2">
              <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B1A1A] block mb-2">Tell me one specific thing you have been thinking about</label>
              <textarea data-testid="mv-form-letter" rows="6" className="w-full bg-transparent border border-[#1A1410]/25 px-4 py-3 outline-none focus:border-[#7B1A1A] resize-none font-serif text-base leading-relaxed" placeholder="Mira, the thing I keep returning to, on most weeks, is…" />
            </div>
            <button type="button" data-testid="mv-form-submit" className="col-span-2 bg-[#7B1A1A] text-[#F4EEE0] px-9 py-4 font-mono text-[10px] tracking-[0.32em] uppercase hover:bg-[#1A1410] transition-colors w-full sm:w-auto sm:justify-self-start">Send the letter →</button>
          </div>
          <div className="mt-9 pt-6 border-t border-[#1A1410]/15 flex items-baseline justify-between text-[#1A1410]/55">
            <p className="font-serif italic text-base">Yours, Mira Vance</p>
            <p className="font-mono text-[9px] tracking-[0.3em] uppercase">Brooklyn / Berlin · Replies within 7 days</p>
          </div>
        </form>

        {/* SIDEBAR */}
        <aside className="lg:sticky lg:top-28 space-y-7">
          <div className="border-l-2 border-[#7B1A1A] pl-5">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B1A1A] mb-2">Mailing address (if you prefer paper)</p>
            <p className="font-serif text-sm text-[#1A1410]/85 leading-[1.65]">M. Vance — Editor<br />The Open Letter, Box 414<br />Brooklyn, NY 11201</p>
          </div>
          <div className="border-l-2 border-[#1A1410]/30 pl-5">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#1A1410]/65 mb-2">Direct, by mail</p>
            <p className="font-serif text-sm text-[#1A1410]/85 leading-[1.65]">post@theopenletter.co</p>
          </div>
          <div className="border-l-2 border-[#1A1410]/30 pl-5">
            <p className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#1A1410]/65 mb-2">Office hours</p>
            <p className="font-serif text-sm text-[#1A1410]/85 leading-[1.65]">Friday afternoons<br />By post, on paper, ideally</p>
          </div>
          <div className="bg-[#1A1410] text-[#F4EEE0] p-5">
            <p className="font-serif italic text-sm leading-[1.7]">&ldquo;You are welcome to write — but please do not write quickly. I will read all the slow ones first.&rdquo;</p>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#C9A06A] mt-3">— M. V.</p>
          </div>
        </aside>
      </section>
    </div>
  );
}

function Field({ label, type = 'text', testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B1A1A] block mb-2" dangerouslySetInnerHTML={{ __html: label }} />
      <input type={type} data-testid={testId} className="w-full bg-transparent border-b border-[#1A1410]/30 px-1 py-2 outline-none focus:border-[#7B1A1A] font-serif text-base" />
    </div>
  );
}
function SelectField({ label, options, testId }) {
  return (
    <div className="col-span-2 sm:col-span-1">
      <label className="font-mono text-[10px] tracking-[0.32em] uppercase text-[#7B1A1A] block mb-2">{label}</label>
      <select data-testid={testId} className="w-full bg-transparent border-b border-[#1A1410]/30 px-1 py-2 outline-none focus:border-[#7B1A1A] font-serif text-base">
        {options.map(o => <option key={o}>{o}</option>)}
      </select>
    </div>
  );
}
